export const FETCH_PROFILE = 'FETCH_PROFILE';
export const PATCH_PROFILE = 'PATCH_PROFILE';
